/*
var ddaytimer = setInterval(dayGap, 1000)
function dayGap () {
    var dday = new Date("May 08, 2025 11:00:00").getTime();//디데이
    var nowday = new Date();
    nowday = nowday.getTime();
    var distance = dday - nowday;

    var d = Math.floor(distance / (1000 * 60 * 60 * 24));//일
    var h = Math.floor((distance / (1000*60*60))% 24);//시간_원래버전
    var m = Math.floor((distance / (1000*60)) % 60);//분
    var s = Math.floor((distance / 1000) % 60);//초

    if(h < 10) h = "0" + h;
    if(m < 10) m = "0" + m;
    if(s < 10) s = "0" + s;
    
    if (distance <= 0) {
        document.getElementById("dday-timer").innerHTML = "D-day";
    } else {
        document.getElementById("time-day").innerHTML = d;
        document.getElementById("time-hour").innerHTML = h;
        document.getElementById("time-minute").innerHTML = m;
        document.getElementById("time-second").innerHTML = s;
    }
}
*/

konnyScript(function($){
  /* 주의사항 펼침 기능 */
  $('.bwWrap .conWrap .notiBox .notiTit').click(function(){
    var notiBox = $(this).parent('.notiBox');
    notiBox.toggleClass('on');
  });

  /* 감사제 특별가 슬라이드 */
  var setSwiper = new Swiper("#bw_prd_swiper_slide1", {
    slidesPerView: 1.08,
    slidesPerGroup: 1,
    spaceBetween: '2.9%',
    scrollbar: {
      el:'#bw_prd_swiper_slide1 .swiper-scrollbar',
    },
    pagination: {
      el:'#bw_prd_swiper_slide1 .swiper-pagination',
    },
  });
  
  /* 감사제 마린 컬렉션 gif 슬라이드 */
  var bwgifSwiper = new Swiper("#bw_gif_swiper_slide1", {
    slidesPerView:1,
    slidesPerGroup:1,
    centeredSlides:true,
    loop:true,
    effect:'fade',
    speed:0,
    autoplay:{
      delay:700,
      disableOnInteraction:false,
    },
  });
  
  /* 마린컬렉션 슬라이드 */
  var setSwiper = new Swiper("#bw_marine_swiper_slide1", {
    slidesPerView: 1.08,
    slidesPerGroup: 1,
    spaceBetween: '2.9%',
    scrollbar: {
      el:'#bw_marine_swiper_slide1 .swiper-scrollbar',
    },
    pagination: {
      el:'#bw_marine_swiper_slide1 .swiper-pagination',
    },
  });

  /* 여름제품 슬라이드 */
  var setSwiper = new Swiper("#bw_ss_swiper_slide1", {
    slidesPerView: 1.04,      // 한 번에 보이는 슬라이드 수
    slidesPerGroup: 1,        // 한 번에 넘길 슬라이드 개수
    spaceBetween: '2.9%',     // 슬라이드 간 간격
    loop: true,               // 슬라이드가 끝나면 처음으로 돌아가는 무한 루프
    speed: 5000,              // 슬라이드 전환 속도 (5000ms = 5초)
    allowTouchMove: true,     // 터치로 슬라이드 이동 가능
    direction: 'horizontal',  // 수평 방향으로 고정
    autoplay: {
      delay: 0,               // 자동 재생 딜레이를 없애서 바로 계속 흐르도록
      disableOnInteraction: false,  // 터치 후에도 autoplay 멈추지 않음
      pauseOnMouseEnter: false,     // 마우스를 올려도 멈추지 않음
    },
    touchRatio: 0.5,          // 스와이프 민감도 조절 (0.5로 설정하여 민감도 감소)
    touchReleaseOnEdges: false, // 끝에서 스와이프 방향 변경 방지
    freeMode: false,          // 자유로운 스크롤(관성) 효과 끄기
    threshold: 10,            // 최소 이동 범위 값 설정
    on: {
      touchStart: function() {
        // 터치가 시작되면 autoplay가 멈추지 않도록 처리
        this.autoplay.stop();
      },
      touchEnd: function() {
        // 터치 종료 시 autoplay가 계속 시작되도록 처리
        this.autoplay.start();
      },
      slideChange: function() {
        // 슬라이드 변경이 있을 때 autoplay가 계속 유지되도록 설정
        this.autoplay.start();
      }
    },
  });
  
  /* 첫구매 슬라이드 */
  var setSwiper = new Swiper("#bw_first_swiper_slide1", {
    slidesPerView: 1.47,
    slidesPerGroup: 1,
    spaceBetween: '6.1%',
    loop: true,
    speed: 3000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });
  
  //Tab Slide
  var bwNavSlide = new Swiper("#bw_nav_swiper_slide1", {
    slidesPerView:'auto',
    grabCursor:true,
    centeredSlides:false,
  });

  //Tab Scroll
  (function () {
    const $tabs = $('.bwWrap .navWrap li');
    const sections = [...Array(8)].map((_, i) => $('#bwCon' + (i + 1)));
    const isMobile = () => $(window).width() <= 750;

    let isFromClick = false;
    let clickTimeout;

    $('#bw_nav_swiper_slide1 a').on('click', function (e) {
      e.preventDefault();
      const $li = $(this).closest('li');
      const index = $li.index();

      clearTimeout(clickTimeout);
      isFromClick = true;
      clickTimeout = setTimeout(() => { isFromClick = false; }, 600);

      $li.addClass('on').siblings().removeClass('on');
      bwNavSlide.slideTo(index);
      $('.bwWrap .navWrap').addClass('fixed');

      const headerHeight = $('#header').outerHeight() || 0;
      const navHeight = $('.bwWrap .navWrap').outerHeight() || 0;
      const fixHeight = headerHeight + navHeight;
      const targetSection = $('#bwCon' + (index + 1));

      if (targetSection.length) {
        const targetTop = targetSection.offset().top - fixHeight + 50;
    
        if (window.scrollY === 0) {
          $('.bwWrap .navWrap').addClass('fixed');
    
          window.scrollTo({ top: 1 });
          setTimeout(() => {
            window.scrollTo({ top: targetTop });
          }, 20);
        } else {
          window.scrollTo({ top: targetTop });
        }
      }

      if (isMobile()) {
        const container = bwNavSlide.el;
        const containerWidth = $(container).width();
        const wrapper = $(container).find('.swiper-wrapper');
        const slideOffset = $li.position().left;
        const slideWidth = $li.outerWidth(true);
        const totalSlides = $tabs.length;
        let scrollX = 0;

        if (index <= 1) {
          scrollX = 0;
        } else if (index >= 2 && index <= 4) {
          scrollX = slideOffset - (containerWidth / 2) + (slideWidth / 2);
        } else {
          const $last = $tabs.last();
          const lastOffset = $last.position().left;
          const lastWidth = $last.outerWidth(true);
          scrollX = (lastOffset + lastWidth) - containerWidth;
        }
        wrapper.css('transform', `translate3d(${-scrollX}px, 0, 0)`);
      }
    });
  
    $(window).on('load scroll', function () {
      if (!$('.bwWrap .navWrap').length || isFromClick) return;

      const headerHeight = $('#header').outerHeight() || 0;
      const navHeight = $('.bwWrap .navWrap').outerHeight() || 0;
      const fixHeight = headerHeight + navHeight;
      const winTop = $(window).scrollTop();
      const bwNavTop = $('.bwWrap .navArea').offset().top - navHeight;

      let activeIndex = 0;

      for (let i = sections.length - 1; i >= 0; i--) {
        if (winTop > sections[i].offset().top - fixHeight) {
          activeIndex = i;
          break;
        }
      }

      if (winTop > bwNavTop) {
        $('.bwWrap .navWrap').addClass('fixed');
      } else {
        $('.bwWrap .navWrap').removeClass('fixed');
      }
  
      const $activeTab = $tabs.eq(activeIndex);
      $activeTab.addClass('on').siblings().removeClass('on');
      bwNavSlide.slideTo(activeIndex);

      if (isMobile()) {
        const container = bwNavSlide.el;
        const containerWidth = $(container).width();
        const wrapper = $(container).find('.swiper-wrapper');
        const slideOffset = $activeTab.position().left;
        const slideWidth = $activeTab.outerWidth(true);
        const totalSlides = $tabs.length;
        let scrollX = 0;

        if (activeIndex <= 1) {
          scrollX = 0;
        } else if (activeIndex >= 2 && activeIndex <= 4) {
          scrollX = slideOffset - (containerWidth / 2) + (slideWidth / 2);
        } else {
          const $last = $tabs.last();
          const lastOffset = $last.position().left;
          const lastWidth = $last.outerWidth(true);
          scrollX = (lastOffset + lastWidth) - containerWidth;
        }
        wrapper.css('transform', `translate3d(${-scrollX}px, 0, 0)`);
      }
    });
  })();
})